import { Controller } from "@hotwired/stimulus";
import { default as $ } from 'jquery';

// Toggles between the Stripe card form and the cash/check/other form on the
// admin payment page. All DOM lookups happen in connect() (not at module load) so
// they work when Turbo navigates to the payment page without reloading the
// bundle.
export default class extends Controller {
  connect() {
    this.stripeForm = $('form.stripe-form');
    this.cashOrCheckForm = $('form.cash-or-check-form');
    // The cash form's hidden field has a unique id (the stripe form renders a
    // field with the same name but a different id).
    this.paymentMethod = $('input#cash_or_check_payment_method');
    this.notes = $('#payment_notes');
    this.submitButton = $('#cash_or_check_submit');

    this.cashOrCheckForm.hide();
    this.stripeForm.hide();
    this.initializeFormToggle();
    // Without Stripe there is no credit-card radio, so start from whichever
    // option the server pre-selected.
    this.setFormMode($('input[type=radio][name=payment-method-toggle]:checked').val() || 'credit-card');
  }

  initializeFormToggle() {
    const self = this;
    $('input[type=radio][name=payment-method-toggle]').on('change', function () {
      self.setFormMode(this.value);
    });
  }

  setFormMode(fType) {
    if (fType == 'credit-card') {
      this.cashOrCheckForm.hide();
      this.stripeForm.show();
      this.paymentMethod.val(fType);
    } else if (fType == 'cash' || fType == 'check' || fType == 'other') {
      this.stripeForm.hide();
      this.cashOrCheckForm.show();
      this.paymentMethod.val(fType);

      const isOther = fType == 'other';
      this.notes.attr('placeholder', isOther ? this.notes.data('other-placeholder') : '');
      this.submitButton.val(isOther ? 'Record payment' : 'Accept cash/check');
    }
  }
}
